<template lang="pug">
.home-page
    section.home-banner
        .container.color-white
            .content-area
                h3 Find A
                h1 Game Master
                    br
                    | Near You
            .header-search-from.banner-search-from
                .row.g-3
                    .col
                        location-search

    section.content-section.pt-120.pb-120(v-if="exclusive.length")
        .container
            .row
                .col-md-12.featured-heading.mb-4
                    h2 Featured Game Masters
                    p Here we’d like to feature some amazing Game Masters who we feel are absolutely amazing. Check them out.
            .row.row-cols-1.row-cols-md-3.g-4.games-listing.slider
                .col(v-for="product in exclusive")
                    game-master-card(:product="product")

    section.content-section.green-bg-color.welcome-slide
        .container
            .row.align-items-center.pt-120.pb-60
                .col-md-6
                    h3 Welcome to Lair-dnd, your home for professional Game Master service.
                    p Our goal is to provide you and your friends the opportunity to find and hire a Game Master for the time and location of your choosing, wherever you plan to end up in the world.
                    p The concept is simple. Create an account and then simply search an area to pull up a list of professional Game Masters to run amazing games for you and your friends. You can book games in your local area, or search a different area you plan on traveling to and book a game for while you’re there.
                .col-md-6
                    img(:src="`${baseUri}/images/client/lairdnd/home-welcome-1.jpg`")
            .row.align-items-center.pb-120
                .col-md-6
                    img(:src="`${baseUri}/images/client/lairdnd/home-welcome-2.jpg`")
                .col-md-6
                    p Once your list of Professional Game Masters populates, you can read through their profiles to find what games they run, what their playstyle is, what add-ons they offer, and be able to book them for a date and time with a few clicks.
                    p Lair-dnd is also the place for Professional Game Masters to link up with groups of players looking to hire a professional that will create a fantastic gaming experience for them and their friends. So, if you have the skills and the passion, and want to earn money doing something you love, create a profile, and let the games begin.
    section.content-section.pt-120.pb-60(v-if="popular.length")
        .container
            .row
                .col-md-12.featured-heading.mb-4
                    h2 Popular Game Masters
                    p Popular Game Masters in our Directory.
            .row.row-cols-1.row-cols-md-3.g-4.games-listing.slider
                .col(v-for="product in popular")
                    game-master-card(:product="product")
    section.content-section.pt-60.pb-60(v-if="reviews.length")
        .container
            .row
                .col-md-12.featured-heading.mb-4
                    h2 Recent Reviews
                    p What People are viewing and reviewing 
            .row
                .col-12.col-md-4
                    .row.row-cols-1.row-cols-md-1.g-4.games-listing.recent-reviews.large
                        .col
                            game-master-card(:product="reviews[0]")
                .col-12.col-md-8
                    .row.row-cols-1.row-cols-md-2.g-4.games-listing.recent-reviews
                        template(v-for="(product, index) in reviews")
                            .col(v-if="index")
                                game-master-card(:product="product" small)
    section.content-section.pt-60.pb-120
        .container
            .row
                .col-md-12.featured-heading.mb-4
                    h2 Featured Games
                    p Our Official list of available games that our Professional Game Masters can run for you is listed here. However, this list is not all encompassing. Many Game Masters have experience with games not currently listed here, so feel free to ask them if they can run the game system you want. As a note, we will be adding MORE games to our Official list in the future.
            .row.row-cols-1.row-cols-md-4.g-4.games-listing.featured-game-listing.slider
                .col(v-for="game in games")
                    .card
                        img.card-img-top(:src="`${baseUri}/images/client/lairdnd/games/${game.image}`" :alt="game.title")
                        .card-body
                            .card-title {{ game.title }}
    section.footer-cta
        subscription-form

</template>

<script>
export default {
    name: 'home-page',

    metaInfo() { return {
        title: this.metaTitle,
        
        meta: [
            { name: 'description', content: this.metaDescription },
            { name: 'og:title', content: `${this.metaTitle} - Lair DND` },
            { name: 'og:description', content: this.metaDescription },
        ],
    }},

    data() { return {
        exclusive: [],
        popular: [],
        reviews: [],
        games: [
            { image: 'dungeons-and-dragons-4-b.jpg', title: 'Dungeons & Dragons 5th edition' },
            { image: 'dungeons-and-dragons.jpg', title: 'Dungeons & Dragons earlier editions' },
            { image: 'shadowrun.jpg', title: 'Shadowrun' },
            { image: 'pathfinder.jpg', title: 'Pathfinder 2nd edition' },
        ],
    }},

    computed: {
        metaTitle() {
            return 'Home Page'
        },
        metaDescription() {
            return 'Our goal is to provide you and your friends the opportunity to find and hire a Dungeon Master for the time and location of your choosing.'
        },
    },

    async created() {
        const { data: { data: exclusive } } = await axios.get('/api/customer/game-master-reservation-product/exclusive?include=user')
        this.exclusive = exclusive

        const { data: { data: popular } } = await axios.get('/api/customer/game-master-reservation-product/popular?include=user')
        this.popular = popular

        const { data: { data: reviews } } = await axios.get('/api/customer/game-master-reservation-product/recent-review?include=user')
        this.reviews = reviews
    },
}
</script>